<template>
    <div class="detail-modal" id="detail-modal">
        <div :class="'resultado-detail-card detail-card-bg-' + cardBg" v-bind="cardDetailsProperties" @click="removeModal">
            <div class="resultado-detail-card-block" v-for="(block,index) in detailCardFields">
                <div class="resultado-detail-column" v-if="page === 'aprovadas' && index === 0"><b-button class="solicitar-anuencia" >Solicitar anuência</b-button></div>
                <div class="line-through" v-if="index > 0"></div>
                <div class="resultado-detail-column" v-for="column in block">     
                    <div class="resultado-detail-item" v-for="element in column">
                        <span v-if="element.key !== 'status' && element.key !== 'actions'"><b>{{element.label}}</b></span>
                        <span v-if="element.key !== 'status' && element.key !== 'actions'">
                            {{
                                (
                                    element.maskDoc ? maskCpfCnpj(item[element.key]) :
                                        (
                                            element.isCurrency ? formatCurrency(item[element.key]) :
                                                (
                                                    element.isDate ? formatDate(item[element.key]) : item[element.key]
                                                )
                                        )
                                )
                            }}
                        </span>
                        <div  v-if="element.key === 'status'" class="detail-status-bar">
                            Status: {{status}}
                        </div>
                        <div class="resultado-detail-actions" v-if="element.key === 'actions'">
                            <span><b>{{element.label}}</b></span>
                            <div class="action-item item-show" @click="exibirPedido(item)">
                                <font-awesome-icon
                                    icon="eye"
                                    size="1x"
                                    style="cursor: pointer"
                                    title="Visualizar"
                                /><span>Visualizar pedido</span>
                            </div>
                            <div class="action-item" @click="exibirRecibo(item)">
                                <div class="recibo-icon" ></div>
                                <span>Recibo</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="modal-bg" @click="removeModal"></div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props:{
            item:[],
            status:'',
            page:String,
            detailCardFields:[],
        },
        filters:{
            
        },
        data() {
            return {
                cardDetailsProperties:{},
                blueButtonStyle:{
                    content:'Solicitar anuência',
                    style:{}
                },
                currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),

            }
        },
        methods: {
            removeModal(event){
                let element = event.target;
                let action = element.closest('div.action-item');
                if(action !== null && action !== undefined){

                }
                else{
                    var modal = document.getElementById('detail-modal');
                    var body = document.body;
                    body.classList.remove('noscroll')
                    modal.remove();
                }
            },
            maskCpfCnpj: function (cpfCnpj){
                if(cpfCnpj.length < 14) return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
                else return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
            },
            formatDate(date){
                if (date !== "" && date !== undefined && date !== null) {
                    let formattedDate = new Date(date);
                    return formattedDate.toLocaleDateString("pt-BR", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    });
                }
                return "";
            },
            formatCurrency(currency){
                if(currency === null || currency === undefined) currency = 0
                return this.currencyFormatter.format(currency);
            },
            exibirRecibo(item){
            },
            exibirPedido(item){
            },
        },
        mounted() {
            this.cardDetailsProperties.style={'width':this.rowWidth + 'px'}
        },
        computed: {
            cardBg: function() {
                switch (this.status) {
                    case 'Pedido enviado. Aguardando orçamento':
                    case 'Comprovante enviado ao cartório.':
                    case 'Protesto cancelado':
                    case 'Protestado':
                        return 'F2F6FE' // azul
                    case 'Aguardando pagamento':
                    case 'Aguardando cotação':
                        return 'FEFDF2' // amarelo
                    case 'Concluído':
                    case 'Finalizado':
                        return 'F2FEF6' // verde
                    case 'Cancelado':
                    case 'Pedido rejeitado':
                        return 'FEF2F2' // vermelho
                    case 'Aguardando orçamento':
                    case 'Cotação Efetuada':
                        return 'FFFFFF' // branco
                    default:
                        return 'F2F6FE' // azul
                }
            }
        }
    }
</script>
<style>
@media (max-width:1199px) {
    .detail-modal{width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        z-index: 100;
        align-items: center;
        justify-content: center;}
    .detail-modal .modal-bg{width:100%;height:100%;background-color: #00000026;}
    .resultado-detail-card {display: flex;flex-flow: column;padding: 11px 12px;width: calc(100% - 40px) !important;height: calc(100% - 60px);position: absolute;border-radius: 5px;box-shadow: 0 3px 6px #00000029;}
        .resultado-detail-card.detail-card-bg-F2F6FE {background: #F2F6FE 0% 0% no-repeat padding-box;} /**    AZUL    **/
        .resultado-detail-card.detail-card-bg-FEFDF2 {background: #FEFDF2 0% 0% no-repeat padding-box;} /**  AMARELO   **/
        .resultado-detail-card.detail-card-bg-F2FEF6 {background: #F2FEF6 0% 0% no-repeat padding-box;} /**   VERDE    **/
        .resultado-detail-card.detail-card-bg-FEF2F2 {background: #FEF2F2 0% 0% no-repeat padding-box;} /**  VERMELHO  **/
        .resultado-detail-card.detail-card-bg-FFFFFF {background: #FFFFFF 0% 0% no-repeat padding-box;} /**   BRANCO   **/
    .resultado-detail-card .resultado-detail-card-block {display: flex;flex-flow: column;padding-bottom: 3px;margin-bottom: 10px;}
    .resultado-detail-card .resultado-detail-card-block:first-child {border-bottom: 1px solid black;}
    .line-through{width: 100%;height: 1px;margin-top: 5px;margin-bottom: 15px;}
        .resultado-detail-card.detail-card-bg-F2F6FE .line-through {background-color: #CBD6F8;} /**    AZUL    **/
        .resultado-detail-card.detail-card-bg-FEFDF2 .line-through {background-color: #F8F5CB;} /**  AMARELO   **/
        .resultado-detail-card.detail-card-bg-F2FEF6 .line-through {background-color: #CBF8D8;} /**   VERDE    **/
        .resultado-detail-card.detail-card-bg-FEF2F2 .line-through {background-color: #F8CBCB;} /**  VERMELHO  **/
        .resultado-detail-card.detail-card-bg-FFFFFF .line-through {background-color: #F1F1F1;} /**   BRANCO   **/
        .resultado-detail-card-block{border: none !important;}
    .resultado-detail-card-block .resultado-detail-column {display: flex;flex-flow: row;flex: 1 1 100% !important;max-width: unset;width: 100%;gap: 40px;}
    .resultado-detail-card-block .resultado-detail-column .resultado-detail-item {display: flex;flex-flow: column;flex: 1 1 100%;max-width: 100%;margin-bottom: 7px;min-height: 54px;}
    .resultado-detail-card-block .resultado-detail-column span {font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;margin-bottom: 7px;}

    .resultado-detail-card-block.block-status{margin: 0;padding: 0;}
        .block-status .resultado-detail-status-button{width: 100%;display: flex;justify-content: flex-end;}
            .detail-status-bar{flex:1;font: normal normal bold 15px/20px 'Kanit', sans-serif; padding: 15px 17px;border-radius: 5px;margin-bottom: 21px;margin-top: 7px;}
            .resultado-detail-card.detail-card-bg-F2F6FE .detail-status-bar{background-color: #CBD6F8;color:#4780F1;} /**    AZUL    **/
            .resultado-detail-card.detail-card-bg-FEFDF2 .detail-status-bar{background-color: #F8F5CB;color:#706927;} /**  AMARELO   **/
            .resultado-detail-card.detail-card-bg-F2FEF6 .detail-status-bar{background-color: #CBF8D8;color:#27703C;} /**   VERDE    **/
            .resultado-detail-card.detail-card-bg-FEF2F2 .detail-status-bar{background-color: #F8CBCB;color:#702727;} /**  VERMELHO  **/
            .resultado-detail-card.detail-card-bg-FFFFFF .detail-status-bar{background-color: #F1F1F1;color:#707070;} /**   BRANCO   **/
            button.solicitar-anuencia{width: 100%;height: 49px;display: flex;justify-content: center;cursor: pointer;align-items: center;background: #F2F6FE 0% 0% no-repeat padding-box;border: 3px solid #4780F1;border-radius: 5px;text-align: left;font: normal normal bold 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #4780F1;margin-bottom: 25px;margin-top: 10px;}
                    button.solicitar-anuencia:hover{background-color: #4780F1;color:white;border: 3px solid #4780F1;}
        
                    .resultado-detail-actions{display: flex;flex-flow: column;}
                    .resultado-detail-actions .action-item{height: 30px;margin-bottom: 14px;display: flex;align-items: center;cursor: pointer;}
                    .resultado-detail-actions .action-item span{font: normal normal bold 15px/20px 'Kanit', sans-serif;margin-bottom: 0;color: #707070;}
                    .resultado-detail-actions .action-item > svg,
                    .resultado-detail-actions .action-item > div {width:30px !important;height: 30px !important;display: flex;justify-content: center;align-items: center;color: #7A7A7A;margin-right: 10px;}
                    .resultado-detail-actions .action-item:hover > * {color:#597EB5;fill:#597EB5;}
                    .resultado-detail-actions .action-item:hover > .recibo-icon {background-image: url("~@/assets/imgs/recibo-azul.png");filter: saturate(4) brightness(0.6);}
}           
</style>